
$(document).ready(function(){
	$(".btn_scorall").click(function() {
		// recalage : des images chargées pendant le défilement déplacent l'offre
		$('html, body').stop().animate({
			scrollTop: $("#slct-pkg").offset().top - 0
		}, 1600, function () {
			var t = $("#slct-pkg").offset().top;
			if (Math.abs($(window).scrollTop() - t) > 20) $('html, body').stop().animate({ scrollTop: t }, 300);
		});
	});
	
	/*SLIDER_FOR_SECTION1_START*/
	
	const thumbSwiper = new Swiper(".sec1_thumbSwiper", {
		spaceBetween:5,
		slidesPerView:5,
		slideToClickedSlide: true,
		watchSlidesProgress: true,
		
		breakpoints: {
			0: {
				slidesPerView:5,
				spaceBetween:0,
				
			},
			768: {
				slidesPerView: 5,
				spaceBetween:8,
				
			},

			1024: {
				spaceBetween: 8,
				slidesPerView:5,
				slideToClickedSlide: true,
				watchSlidesProgress: true,
			}
		  },
	});
	
	const mainSwiper = new Swiper(".sec1_mainSwiper", {
		spaceBetween:15,
		slidesPerView:1.1,
		loop: true,
		speed: 600,
		centeredSlides: true,
		thumbs: {
			swiper: thumbSwiper,
		},
		
		navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
		
		pagination: {
			el: ".s1-swiper-pagination",
			clickable: true,
		},
		
		breakpoints: {
			768: {
				slidesPerView: 3,
				spaceBetween:20,
				
			},

			1024: {
				centeredSlides: true,
				slidesPerView: 3,
				spaceBetween: 21,
			}
		  },
	});
	
	/*SLIDER_FOR_SECTION1_END*/
	
	$('.more-review').click(function(e) {
		$('.testimonial-hide').fadeIn();
		$('.more-review-link').hide();
	});
		
	
	// for slider
	// peu de vidéos (vrais témoignages seulement) : pas de boucle, diapos centrées
	var vdoCount = document.querySelectorAll('.video_slide_row .swiper-slide').length;
	var swiper = new Swiper(".video_slide_row", {
		spaceBetween:15,
		slidesPerView:1.5,
		loop: vdoCount >= 6,
		centerInsufficientSlides: true,
		
		navigation: {
		  nextEl: ".video_slide-button-next",
		  prevEl: ".video_slide-button-prev",
		},
		
		 pagination: {
			el: ".swiper-pagination",
			clickable: true,
		  },
		  
		
		breakpoints: {
			0: {slidesPerView:1.3, spaceBetween:15, parallax:true, centeredSlides: true,},
			768: {slidesPerView:3,centeredSlides: false,},
			// 🖥 Desktop
			1021: { slidesPerView:4,spaceBetween: 25,centeredSlides: false,},
		},
	});	
	
	//video
	var video = $('#myVdo video')[0];
	
	$('.ugc1').click(function(e) {
		$('.ugc-modal').addClass('active');
		$('.video-container').show();
		
		var videoFile = $(this).attr('data-vdo');
		video.src = videoFile;
		video.load();
		video.play();
    });	
	
	$('.ugc-close, .ugc-modal').click(function(e) {
		video.src = '';
       	$('.ugc-modal').removeClass('active');
	   	$('.video-container').hide();
    });	
	
	//Accordion JS 
	$(".acdn-heading").click(function() {
			
		var questionDiv = $(this);
		var answerDiv   = $(this).next('.acdn-content');
		var idx = $('.acdn-content').index(answerDiv);
		
		$('.acdn-content').each(function(index, ansDiv) {
			if(index != idx && $(ansDiv).is(':visible')) {
				$(ansDiv).slideUp(500, function() {
					$(ansDiv).prev('.acdn-heading').removeClass('accordion-open');
				});
			}
		});
					
		if (answerDiv.is(':visible')) {
			answerDiv.stop().slideUp(500, function() {
				questionDiv.removeClass('accordion-open');
			});
		} else {
		  questionDiv.addClass('accordion-open');
		  answerDiv.stop().slideDown(500);
		}
	
	});
	
	//Discount Timer
	clock();
	
		
});

var myTimer;

function clock() {
    var totalSeconds = 3 * 55 * 60; // 3 hours 55 minutes

    myTimer = setInterval(myClock, 1000);
	
	myClock(); // Show initial time immediately

    function myClock() {
        var hours = Math.floor(totalSeconds / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        // Add leading zeros
        hours = String(hours).padStart(2, "0");
        minutes = String(minutes).padStart(2, "0");
        seconds = String(seconds).padStart(2, "0");

        var result = hours + ":" + minutes + ":" + seconds;

        var countdown2 = document.getElementsByClassName("listicle-count");

        for (var index = 0; index < countdown2.length; index++) {
            countdown2[index].innerHTML = result;
        }

        // Stop at 00:00:00
        if (totalSeconds <= 0) {
            clearInterval(myTimer);
            return;
        }

        totalSeconds--;
    }
    
}

/* ---- */

  function distanceCalculation(div1, div2) {
    // Get the dimensions and positions of the divs
    const rect1 = div1.getBoundingClientRect();
    const rect2 = div2.getBoundingClientRect();

    // Calculate the center of each div
    const center1 = {
      x: rect1.left + rect1.width / 2,
      y: rect1.top + rect1.height / 2,
    };

    const center2 = {
      x: rect2.left + rect2.width / 2,
      y: rect2.top + rect2.height / 2,
    };

    // Calculate the distance using the Pythagorean theorem
    const distance = Math.sqrt(Math.pow(center2.x - center1.x, 2) + Math.pow(center2.y - center1.y, 2));

    return distance;
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Cache DOM selections and constant values
    const timelineSteps = Array.from(document.querySelectorAll('.timeline__row_center_step'));
    const contentBoxes = Array.from(document.querySelectorAll('.timeline__row_content_box'));
    const timelineSection = document.querySelector('.timeline__mid');
    const timelineEntryPoint = document.querySelector('.timeline__mid_row');
    const firstTimelineStep = timelineSteps[0];
    const lastTimelineStep = timelineSteps[timelineSteps.length - 1];

    let distanceBetweenSteps = 0;
    let stepDistances = [];
    let ticking = false; // For scroll throttling

    function setTimelineHeight() {
      distanceBetweenSteps = distanceCalculation(firstTimelineStep, lastTimelineStep);
      timelineEntryPoint.style.setProperty('--timeline-height', `${distanceBetweenSteps}px`);
      stepDistances = timelineSteps.map((step) => distanceCalculation(firstTimelineStep, step));
    }

    function updateTimelineHeight() {
      const sectionRect = timelineSection.getBoundingClientRect();

      // Skip update if section is not visible
      if (sectionRect.bottom < 0 || sectionRect.top > window.innerHeight) {
        ticking = false;
        return;
      }

      const viewportMiddle = window.innerHeight * 0.85; // Simplified viewport middle point
      const distanceFromMiddle = sectionRect.top - viewportMiddle;
      const sectionHeight = sectionRect.height;

      let newHeight, shouldAddViewing;

      // If we haven't scrolled to the section yet (section is below viewport middle)
      if (distanceFromMiddle > 0) {
        newHeight = 0;
        shouldAddViewing = false;
      }
      // If we've scrolled past the entire section
      else if (distanceFromMiddle <= -sectionHeight) {
        newHeight = distanceBetweenSteps;
        shouldAddViewing = true;
      }
      // If we're currently scrolling through the section
      else {
        // Calculate progress (0 to 1) based on how far we've scrolled through the section
        const scrollProgress = Math.min(Math.abs(distanceFromMiddle) / sectionHeight, 1);
        // Set timeline height proportional to scroll progress
        newHeight = scrollProgress * distanceBetweenSteps;
        // Let individual steps determine their viewing state based on height
        shouldAddViewing = null;
      }

      timelineEntryPoint.style.setProperty('--timeline-height-dynamic', `${newHeight}px`);

      // Class manipulation optimization
      timelineSteps.forEach((step, index) => {
        const shouldView = shouldAddViewing !== null ? shouldAddViewing : newHeight >= stepDistances[index];
        step.classList.toggle('viewing', shouldView);
        if (contentBoxes[index]) {
          contentBoxes[index].classList.toggle('viewing', shouldView);
        }
      });

      ticking = false;
    }

    // Throttled scroll handler
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(() => {
          updateTimelineHeight();
        });
        ticking = true;
      }
    }

    // Event listeners with throttling
    window.addEventListener('scroll', onScroll, { passive: true });
    const debouncedResize = debounce(setTimelineHeight, 250);
    window.addEventListener('resize', debouncedResize);

    // Debounce function
    function debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    // Init
    setTimelineHeight();
    updateTimelineHeight();
  });

/* ---- */


// COUNTER FUNCTION
function VanillaCounter() {
    let elements = document.querySelectorAll('[data-vanilla-counter]');

    elements.forEach(i => {

        let start = parseInt(i.getAttribute('data-start-at')) || 0;
        let end = parseInt(i.getAttribute('data-end-at')) || 0;
        let delay = parseInt(i.getAttribute('data-delay')) || 0;
        let time = parseInt(i.getAttribute('data-time')) || 1000;

        let counter = start;
        let stepTime = Math.abs(Math.floor(time / (end - start)));

        i.innerHTML = counter;

        setTimeout(() => {
            let interval = setInterval(() => {

                counter += (end > start ? 1 : -1);
                i.innerHTML = counter;

                if (counter == end) {
                    clearInterval(interval);
                }

            }, stepTime);
        }, delay);

    });
}


// SCROLL TRIGGER
var triggered = false;

$(window).on('scroll', function () {

    var sectionTop = $('.running-bar').offset().top - 600;
    var scrollTop = $(window).scrollTop();

    if (scrollTop > sectionTop && !triggered) {

        triggered = true;

        // Progress bar animation
        $('.result_box-row').each(function () {
            var value = $(this).attr('data-wdth');

            $(this).find('.result_bar_inr').css('width', value + '%');
        });

        // Start counter
        VanillaCounter();
    }

});


/* ---- */

	(() => {
      const n = new Date();
      let countDownDate = new Date(n.getFullYear(), n.getMonth(), n.getDate(), 14, 0);
      const x = setInterval(function () {
        const currentDate = new Date();
        const estData = currentDate.toLocaleString('en-US', {
          timeZone: 'America/New_York',
          hour12: false,
        });

        const limitHour = parseInt(estData.split(' ')[1].split(':')[0]);

        if (limitHour > 14) {
          countDownDate = new Date(n.getFullYear(), n.getMonth(), n.getDate(), 14, 0);
          const tomorrowTime = countDownDate.getTime() + 86400000;

          let distance = Math.abs(currentDate - tomorrowTime);
          let days = Math.floor(distance / (1000 * 60 * 60 * 24));
          let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          let seconds = Math.floor((distance % (1000 * 60)) / 1000);


          document.querySelectorAll('.within-time').forEach((element) => {
            element.innerHTML = hours + 'hr ' + minutes + 'mins ' + seconds + 'sec';
          });
          document.querySelectorAll('.shipping__message--today').forEach((element) => {
            element.style.display = 'none';
          });
          document.querySelectorAll('.shipping__message--tomorrow').forEach((element) => {
            element.style.display = 'block';
          });
          return;
        }
        const now = countDownDate.getTime();
        let distance = Math.abs(currentDate - now);
        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);

        document.querySelectorAll('.remain-time').forEach((element) => {
          element.innerHTML = hours + 'hr ' + minutes + 'mins ' + seconds + ' sec';
        });
        
        document.querySelectorAll('.shipping__message--today').forEach((element) => {
          element.style.display = 'block';
        });
        document.querySelectorAll('.shipping__message--tomorrow').forEach((element) => {
          element.style.display = 'none';
        });
      }, 1000);
    })();

/* ---- */

function isScrolledIntoView(elem) {
	var docViewTop = $(window).scrollTop();
	var docViewBottom = docViewTop + $(window).height();
	
	var elemTop = $(elem).offset().top;
	var elemBottom = elemTop + $(elem).height();
	
	return ((elemTop <= docViewBottom) && (elemBottom >= docViewTop));
}
$(document).scroll(function() {
	//bottom fixed button
	var winscroll2 = $(window).scrollTop()
	var scrlbtn2 = $('.sticky-btn-show').offset().top + 100;
	
	
	if (winscroll2 > scrlbtn2 ){
		$('#call-btn').show();
	}else{
		$('#call-btn').hide();
	}
	
	var $elem = $('.footer');
	var $window = $(window);

	var docViewTop = $window.scrollTop();
	var docViewBottom = docViewTop + $window.height();

	var elemTop = $elem.offset().top;
	var elemBottom = elemTop + $elem.height();
	
	if (elemTop >= (docViewBottom + 0) || (elemTop + $('#call-btn').height()) >= (docViewBottom + 104)) {
			
		if (isScrolledIntoView('#slct-pkg') === true) {
			$('#call-btn').css('position', 'relative');
			
		} else {
			$('#call-btn').css('position', 'fixed');
		}
	} else {
		$('#call-btn').css({'position' : 'relative'});
	}

});
